import LiveInputs from './live_inputs_class'

export default (function () {
  LiveInputs.initClass()
  return LiveInputs
})()
